import { t } from './i18n';

// The designation lives in housingVariant on the construction number, which is
// what the detail page hero already prefers over the housing type description
// (project-page-hero-brick/variants/constructionNumber.html.twig). It is also
// the more precise of the two: a construction number with variant "B1" hangs off
// a housing type described as "Hoekwoning - type B" (WHN-2146).
//
// Editors fill it inconsistently. Of the 7362 filled rows in the database 6655
// hold a bare code ("C", "A1"), 486 repeat the word type ("type C") and 221
// repeat the kind ("Hoekwoning B2"). Both prefixes are stripped so the label
// never reads "type type C" or "Hoekwoning - type Hoekwoning B2".

// housingKind is free text from the CMS and does contain regex metacharacters:
// "(Semi)bungalows" is one of the 97 values in use. Unescaped it would read as a
// capture group and match "Semibungalows" instead of the literal kind, and a
// value with an unbalanced bracket would make the constructor throw while a
// title renders.
const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const stripPrefix = (variant, kind) => {
  let value = variant.trim();

  if (kind) {
    const kindPrefix = new RegExp(`^${escapeRegExp(kind.trim())}\\s+`, 'i');
    value = value.replace(kindPrefix, '');
  }

  return value.replace(/^type\s+/i, '').trim();
};

export const housingTitle = ({ housingKind, housingVariant, housingType } = {}) => {
  const kind = housingKind || '';
  const variant = housingVariant ? stripPrefix(housingVariant, kind) : '';

  if (kind && variant) return t('listing-card.type-designation', { kind, variant });

  return kind || housingType || '';
};

// The card and the detail panel name a home the same way (WHN-2171): the
// designation plus the construction number, which is what tells apart the
// identical homes one housing type can hold.
export const housingTitleWithNumber = (listing = {}) => {
  const designation = housingTitle(listing);
  const number = listing.constructionNumber
    ? t('listing-detail.bnr', { number: listing.constructionNumber })
    : '';

  return [designation, number].filter(Boolean).join(' – ');
};
